module.exports = {

    getUrlParam : function(name, def) {

        if(typeof def === 'undefined'){
            def = null;
        }

        name        = name.replace(/[\[\]]/g, '\\$&');
        let url     = window.location.href,
            regex   = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);

        if (!results)    return def;
        if (!results[2]) return '';

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    preloadImage: function(src){
        img = new Image();
        img.src = src;
    },

    executeOnce: function() {
        var argc = arguments.length, bImplGlob = typeof arguments[argc - 1] === "string";
        if (bImplGlob) { argc++; }
        if (argc < 3) { throw new TypeError("executeOnce - not enough arguments"); }
        var fExec = arguments[0], sKey = arguments[argc - 2];
        if (typeof fExec !== "function") { throw new TypeError("executeOnce - first argument must be a function"); }
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { throw new TypeError("executeOnce - invalid identifier"); }
        if (unescape(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) === "1") { return false; }
        fExec.apply(argc > 3 ? arguments[1] : null, argc > 4 ? Array.prototype.slice.call(arguments, 2, argc - 2) : []);
        document.cookie = escape(sKey) + "=1; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=" + ((bImplGlob ? false : arguments[argc - 1]) ? location.pathname : "/");
        return true;
    },

    animateCss: function(animationName, callback) {
        var animationEnd = (function(el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        })(document.createElement('div'));

        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName);

            if (typeof callback === 'function') callback();
        });

        return this;
    },

    invisible:  function() {
        return this.each(function () {
            $(this).css("visibility", "hidden");
        });
    },


    visible: function() {
        return this.each(function () {
            $(this).css("visibility", "visible");
        });
    }

};


// WEBPACK FOOTER //
// ./resources/js/n.js